import ensureZepto from 'amkit3-modules/utils/ensure-zepto'

const fallbackImgSrc = (el, fallback) => {
  ensureZepto((_, $) => {
    $(el).on('error', () => {
      if ($(el).prop('src') !== fallback) {
        $(el).prop('src', fallback)
      }
    })
  })
}

export default fallbackImgSrc
